import { TextStyle } from "./common";
const baseCodeBlockData = {};
const CodeBlockData = {
  fromJSON(object) {
    const message = { ...baseCodeBlockData };
    message.textStyle = object.textStyle !== void 0 && object.textStyle !== null ? TextStyle.fromJSON(object.textStyle) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.textStyle !== void 0 && (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : void 0);
    return obj;
  }
};
export {
  CodeBlockData
};
//# sourceMappingURL=node_code_block.js.map
